import { Check } from 'lucide-react'

export const CliSignupSuccess = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
      <Check className="h-8 w-8 text-green-600" />
    </div>
    <h1 className="text-2xl font-semibold text-foreground">Signup complete!</h1>
    <p className="text-muted-foreground">You can close this tab and return to your terminal.</p>
  </div>
)
